import { render } from "./SystemIcon.vue?vue&type=template&id=a54faf1c"
import script from "./SystemIcon.vue?vue&type=script&lang=js"
export * from "./SystemIcon.vue?vue&type=script&lang=js"

import "./SystemIcon.vue?vue&type=style&index=0&id=a54faf1c&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__